function getTitle(vm) {
  const { title } = vm.$options;
  if (title) {
    const result = typeof title === 'function' ? title.call(vm) : title;
    return `${result} - Reverse Coding - 2022`;
  }
  return 'Reverse Coding - 2022';
}
export default {
  created() {
    const title = getTitle(this);
    if (title) {
      document.title = title;
    }
  },
};
